import MapConstructor from "../map/MapConstructor";
import {singleUpload} from "../image_uploader";
import {geocoderAddress} from "../helpers/helpersGeo";




window.addEventListener('load', function(){

    let eventRoute;

    let mapConstructor = new MapConstructor({
        savedStorage: $('input[event_id]').length === 0,
        onClose: () => {
            mapConstructor.aligment();
        },
        onClickNext: function(){
            if(mapConstructor.type === 'route'){

                if(mapConstructor.getRoutePoints().length < 2){
                    $.alert({
                        title: 'Notice',
                        content: 'Please add at least start and end points',
                        boxWidth: 340
                    });
                    return;
                }

                createRoute(
                    mapConstructor.getRoutePoints(),
                    mapConstructor.getRoutePath(),
                    mapConstructor.getRouteDistance(),
                    (eventRoute && eventRoute.id ? eventRoute.id : undefined)
                ).then(route => {

                    eventRoute = route;

                    $('input#route').val(route.key);
                    $('#routeSteps').html(renderRouteSteps(mapConstructor.getRoutePoints(), true));
                    $('.mapConstructor').removeClass('full');

                    mapConstructor.hideZoomControl();
                    mapConstructor.aligment();
                    mapConstructor.onUpdateRoutePath();

                    ScrollTo('.mapConstructor');

                    geocoderAddress(mapConstructor.markerArr[0], true);

                }).catch(() => {
                    return false;
                })

            }else{

                if(mapConstructor.point === null){
                    $.alert({
                        title: 'Notice',
                        content: 'Please mark the location of the event on the map',
                        boxWidth: 340
                    });
                    return;
                }

                geocoderAddress(mapConstructor.point, true);

                $('input#address').val(mapConstructor.point.data.address);
                $('input#latitude').val(mapConstructor.point.position['lat']);
                $('input#longitude').val(mapConstructor.point.position['lng']);

                $('.mapConstructor').removeClass('full');
                ScrollTo('.mapConstructor');
                mapConstructor.hideZoomControl();
                mapConstructor.aligment();

            }

        }
    });

    singleUpload("#filesUpload", 920, function(th, url, key){
        $('.event_cover_upload > img').prop('src', url);
        $('.event_cover_upload > input[name=cover]').val(key);
    });

    $('.form-hide_item__text').on('click', function(e){
        e.preventDefault();
        $(this).closest('.form-hide_item').addClass('active');
    });

    $('.form-h.spoiler').on('click', function(){
        $(this).next('fieldset').slideDown();
    })

    let bottomTexts = new Map;
    bottomTexts.set('point', 'Choose a meeting point by tapping or searching the map, and then click on the next button to continue adding the event.');
    bottomTexts.set('route', 'Choose a meeting point by tapping or searching the map and continue tapping on the map to add waypoints, and then click on the next button to continue adding the group ride.');

    if($('input[name=event_id]').length === 0){
        $.dialog({
            title: 'Please, select type',
            boxWidth: 400,
            closeIcon: false,
            draggable: false,
            bgOpacity: 0.8,
            titleClass: 'center_dialog_title',
            content: () => {
                return '<div class="s_event_type"><div><div class="s_event_type-b" data-type="point"><div><i class="icon-event_point"></i></div><div>EVENT</div></div></div><div><div class="s_event_type-b" data-type="route"><div><i class="icon-event_route"></i></div><div>GROUP RIDE</div></div></div></div>'
            }
        });

        $(document).on('click', '.s_event_type-b', function(){
            let constructorContainer = $('.mapConstructor');
            $('.jconfirm').remove();
            let type = $(this).data('type');
            mapConstructor.setTypeMap(type);
            mapConstructor.setBottomText(bottomTexts.get(type));
            constructorContainer.append(mapConstructor.getMapContainer());
            mapConstructor.initMap();
            if(type === 'route'){
                $('#eventCategory').addClass('hide');
                let json_point = window.localStorage.getItem('route');
                if(json_point) mapConstructor.showRoute(json_point);
            }
            mapConstructor.showFullMap();
            constructorContainer.addClass('full');
        })
    }else{
        let routeKey = $('input[name=route]').val();

        if(routeKey.length > 0){

            $.get("/ajax/getRouteByKey", {key: routeKey}, function(d){

                mapConstructor.setTypeMap('route');
                mapConstructor.setBottomText(bottomTexts.get('route'));
                $('.mapConstructor').append(mapConstructor.getMapContainer());

                mapConstructor.initMap();

                $('#eventCategory').addClass('hide');
                $('.maps_sidebar--bottom').addClass('route');

                let res = ParseResp(d);
                if(res){

                    eventRoute = res.data.route;

                    mapConstructor.showRoute(eventRoute.route_points);
                    $('#routeSteps').html(renderRouteSteps(eventRoute.route_points, true));

                }

            })

        }else{

            mapConstructor.setBottomText(bottomTexts.get('point'));
            mapConstructor.setTypeMap('point');
            $('.maps_sidebar--bottom').addClass('event');
            $('.mapConstructor').append(mapConstructor.getMapContainer());
            mapConstructor.initMap();
            mapConstructor.placePoint(mapConstructor.createGoogleLatLng($('input[name=latitude]').val(), $('input[name=longitude]').val()));

        }

    }

    $(document).on('click', '.openMap', function(e){
        e.preventDefault();
        mapConstructor.showFullMap();
        $('.mapConstructor').addClass('full');
    })

    $(document).on('click', '.point_in_form .edit_overlay', function(){
        let index = $(this).closest('.point_in_form').data('index');
        mapConstructor.renderDialogForEditMarker(mapConstructor.markerArr[index]);
    })

    updateDatepicker();

    callbackFabric.add('resetStorage', function(){
        mapConstructor.resetStorage();
    });

})